export default __webpack_public_path__ + "static/media/IMG11.da5b0cdd.jpeg";